export const getInvitationCreateAccountPath = (invitationCode: string, search: string = ""): string => {
    return `/createAccount/${invitationCode}${search}`;
};

export const getInvitationSignInPath = (invitationCode: string, search: string = ""): string => {
    return `/login/${invitationCode}${search}`;
};
